/* eslint-disable max-len */
import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

import { passIf } from '@utils';

export enum PhoneFrameSvgStyleEnum {
  Dark = 'dark',
  Light = 'light',
}

function getColorsFromStyle(style: PhoneFrameSvgStyleEnum) {
  return style === PhoneFrameSvgStyleEnum.Dark
    ? ['#312E2E', '#312E2E', '#3C3838', '#312E2E']
    : ['#F3F3F3', '#F3F3F3', '#F8F8F8', '#F3F3F3'];
}

const PATHS = [
  'M230.483.475H39.311C18.74.475 2.068 17.177 2.068 37.78v464.439c0 20.603 16.673 37.305 37.24 37.305h191.174c20.568 0 37.241-16.702 37.241-37.305V37.78c.001-20.603-16.672-37.305-37.24-37.305Zm-6.01 11.409H49.33c-18.843 0-34.119 15.906-34.119 35.528v442.324c0 19.622 15.276 35.528 34.12 35.528h175.142c18.843 0 34.119-15.906 34.119-35.528V47.412c0-19.622-15.276-35.528-34.119-35.528Z',
  'M39.31.95C19.006.95 2.544 17.44 2.544 37.78v464.439c.001 20.342 16.463 36.83 36.767 36.83h191.173c20.304 0 36.766-16.488 36.766-36.829V37.78c0-20.341-16.462-36.83-36.766-36.83H39.311ZM1.593 37.78C1.593 16.915 18.48 0 39.31 0h191.173c20.831 0 37.716 16.915 37.716 37.78v464.439c0 20.865-16.885 37.78-37.716 37.78H39.311c-20.832 0-37.718-16.915-37.718-37.78V37.78ZM49.33 12.36c-18.562 0-33.643 15.674-33.643 35.052v442.324c0 19.378 15.08 35.053 33.643 35.053h175.143c18.562 0 33.643-15.675 33.643-35.053V47.412c0-19.378-15.081-35.053-33.643-35.053H49.33ZM14.736 47.411c0-19.866 15.47-36.004 34.594-36.004h175.143c19.123 0 34.594 16.138 34.594 36.004v442.324c0 19.866-15.471 36.003-34.594 36.003H49.33c-19.123 0-34.594-16.137-34.594-36.003V47.412Z',
  'M229.862 3.584H39.931c-19.197 0-34.758 15.589-34.758 34.818v463.197c0 19.229 15.56 34.818 34.758 34.818h189.931c19.197 0 34.759-15.589 34.759-34.818V38.402c0-19.23-15.562-34.817-34.759-34.817ZM18.62 40.034c0-12.576 10.19-22.77 22.76-22.77h25.034v.01a2.483 2.483 0 0 1 2.69 2.476v1.24c0 8.233 6.678 14.903 14.917 14.903H185.98c8.238 0 14.918-6.672 14.918-14.903v-1.267a2.486 2.486 0 0 1 1.684-2.327 2.48 2.48 0 0 1 1.006-.124v-.008h25.035c12.569 0 22.757 10.193 22.757 22.77v458.693c0 12.575-10.188 22.768-22.757 22.768H41.379c-12.569 0-22.758-10.193-22.758-22.768V40.032v.001Z',
  'M107.586 25.347a2.488 2.488 0 0 0 0-4.974 2.482 2.482 0 0 0-2.294 1.535 2.484 2.484 0 0 0 .538 2.71 2.474 2.474 0 0 0 1.756.729Zm57.518 1.656a4.147 4.147 0 0 0 2.927-1.216 4.151 4.151 0 0 0 .897-4.514 4.153 4.153 0 0 0-2.239-2.244 4.146 4.146 0 0 0-1.585-.316 4.142 4.142 0 0 0-4.138 4.145 4.134 4.134 0 0 0 4.138 4.145ZM121.241 21.2h27.725a1.657 1.657 0 1 1 0 3.316h-27.725a1.658 1.658 0 0 1 0-3.316ZM0 112.8c0-.456.444-.827.995-.827h1.487v39.377H.995c-.55 0-.995-.371-.995-.827V112.8Zm0 49.118c0-.456.444-.827.995-.827h1.487v39.377H.995c-.55 0-.995-.37-.995-.827v-37.723Zm0-87.664c0-.457.444-.83.995-.83h1.487V94.98H.995c-.55 0-.995-.37-.995-.829V74.255Zm267.517 50.153h1.241c.686 0 1.242.463 1.242 1.036v62.176c0 .572-.557 1.035-1.242 1.035h-1.241v-64.247Z',
];

export interface IPhoneFrameSvgProps extends SvgProps {
  frameStyle?: PhoneFrameSvgStyleEnum;
}

export function PhoneFrameSvg({
  frameStyle = PhoneFrameSvgStyleEnum.Dark,
  ...props
}: IPhoneFrameSvgProps) {
  const colors = getColorsFromStyle(frameStyle);

  return (
    <Svg width={270} viewBox="0 0 270 540" {...props}>
      {PATHS.map((_, index) => {
        const rule = passIf(index === 0, 'evenodd');
        return (
          <Path
            key={index}
            fillRule={rule}
            clipRule={rule}
            d={PATHS[index]}
            fill={colors[index]}
          />
        );
      })}
    </Svg>
  );
}
